import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Introduce from '../views/Introduce.vue'
import Download from '../views/Download.vue'
import Webpush from '../views/Webpush.vue'
import Agent from '../views/Agent.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '掌柜助手 - 首页' }
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component: Introduce,
    meta: { title: '产品介绍 - 掌柜助手' }
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
    meta: { title: '产品下载 - 掌柜助手' }
  },
  {
    path: '/webpush',
    name: 'Webpush',
    component: Webpush,
    meta: { title: '离线通知 - 掌柜助手' }
  },
  {
    path: '/agent',
    name: 'Agent',
    component: Agent,
    meta: { title: '代理加盟 - 掌柜助手' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '掌柜助手'
  next()
})

export default router
